var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 5.00001C1.25 3.59168 2.39167 2.45001 3.8 2.45001H20.2C21.6069 2.45001 22.75 3.58642 22.75 4.99613V18.225C22.75 18.5288 22.5038 18.775 22.2 18.775C21.8962 18.775 21.65 18.5288 21.65 18.225V4.99613C21.65 4.19671 21.0022 3.55001 20.2 3.55001H3.8C2.99919 3.55001 2.35 4.1992 2.35 5.00001V18.4C2.35 19.2008 2.99919 19.85 3.8 19.85H20.7C21.0038 19.85 21.25 20.0963 21.25 20.4C21.25 20.7038 21.0038 20.95 20.7 20.95H3.8C2.39167 20.95 1.25 19.8083 1.25 18.4V5.00001Z",
    fill: "#383634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 23.35C17.6962 23.35 17.45 23.1038 17.45 22.8V19.85H18.55V22.8C18.55 23.1038 18.3038 23.35 18 23.35Z",
    fill: "#383634"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 23.35C5.69624 23.35 5.45 23.1038 5.45 22.8V19.85H6.55V22.8C6.55 23.1038 6.30376 23.35 6 23.35Z",
    fill: "#383634"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63313 10.85H13.1669C12.9327 10.0969 12.2302 9.55001 11.4 9.55001C10.5698 9.55001 9.86732 10.0969 9.63313 10.85ZM8.45 11.4C8.45 9.77077 9.77076 8.45001 11.4 8.45001C13.0292 8.45001 14.35 9.77077 14.35 11.4C14.35 11.7038 14.1038 11.95 13.8 11.95H9C8.69624 11.95 8.45 11.7038 8.45 11.4Z",
    fill: "#383634"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83313 11.95H8.36687C8.13268 12.7032 7.4302 13.25 6.6 13.25C5.7698 13.25 5.06732 12.7032 4.83313 11.95ZM3.65 11.4C3.65 13.0293 4.97076 14.35 6.6 14.35C8.22924 14.35 9.55 13.0293 9.55 11.4C9.55 11.0963 9.30376 10.85 9 10.85H4.2C3.89624 10.85 3.65 11.0963 3.65 11.4Z",
    fill: "#383634"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45 10.7669V7.23314C7.69685 7.46733 7.15 8.16981 7.15 9.00001C7.15 9.83021 7.69685 10.5327 8.45 10.7669ZM9 11.95C7.37076 11.95 6.05 10.6293 6.05 9.00001C6.05 7.37077 7.37076 6.05001 9 6.05001C9.30376 6.05001 9.55 6.29626 9.55 6.60001L9.55 11.4C9.55 11.7038 9.30376 11.95 9 11.95Z",
    fill: "#383634"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55 12.0331V15.5669C10.3031 15.3327 10.85 14.6302 10.85 13.8C10.85 12.9698 10.3031 12.2673 9.55 12.0331ZM9 10.85C10.6292 10.85 11.95 12.1708 11.95 13.8C11.95 15.4293 10.6292 16.75 9 16.75C8.69624 16.75 8.45 16.5038 8.45 16.2V11.4C8.45 11.0963 8.69624 10.85 9 10.85Z",
    fill: "#383634"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.35 7.20001C20.35 7.50377 20.1038 7.75001 19.8 7.75001H16.8C16.4962 7.75001 16.25 7.50377 16.25 7.20001C16.25 6.89626 16.4962 6.65001 16.8 6.65001H19.8C20.1038 6.65001 20.35 6.89626 20.35 7.20001Z",
    fill: "#383634"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.35 9.60001C20.35 9.90377 20.1038 10.15 19.8 10.15H16.8C16.4962 10.15 16.25 9.90377 16.25 9.60001C16.25 9.29626 16.4962 9.05001 16.8 9.05001H19.8C20.1038 9.05001 20.35 9.29626 20.35 9.60001Z",
    fill: "#383634"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.35 12C20.35 12.3038 20.1038 12.55 19.8 12.55H16.8C16.4962 12.55 16.25 12.3038 16.25 12C16.25 11.6963 16.4962 11.45 16.8 11.45H19.8C20.1038 11.45 20.35 11.6963 20.35 12Z",
    fill: "#383634"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.35 14.4C20.35 14.7038 20.1038 14.95 19.8 14.95H16.8C16.4962 14.95 16.25 14.7038 16.25 14.4C16.25 14.0963 16.4962 13.85 16.8 13.85H19.8C20.1038 13.85 20.35 14.0963 20.35 14.4Z",
    fill: "#383634"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.35 16.8C20.35 17.1038 20.1038 17.35 19.8 17.35H16.8C16.4962 17.35 16.25 17.1038 16.25 16.8C16.25 16.4963 16.4962 16.25 16.8 16.25H19.8C20.1038 16.25 20.35 16.4963 20.35 16.8Z",
    fill: "#383634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatPump);
export default __webpack_public_path__ + "static/media/heat_pump.6de1a0a14a75c4e4edefa49c0f440570.svg";
export { ForwardRef as ReactComponent };